import React from 'react';
import {
  LedgerHeader,
  ledgerContainerClass,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';
import { LabourItemDefinition } from '../../api/labourItemsApi';
import { LabourItemListItem } from '../molecules/LabourItemListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

interface LabourItemsListViewProps {
  items: LabourItemDefinition[];
  loading: boolean;
  onItemClick: (id: string) => void;
  disabled?: boolean;
}

const ITEMS_COLLAPSE: LedgerCollapse = {
  container: 'labour-items-collection',
  at: 620,
};

const ITEMS_COLUMNS: LedgerColumn[] = [
  { key: 'usedBy', label: 'Used by', flex: 0.8, align: 'end' },
];

export const LabourItemsListView: React.FC<LabourItemsListViewProps> = ({
  items,
  loading,
  onItemClick,
  disabled,
}) => {
  return (
    <div className={ledgerContainerClass(ITEMS_COLLAPSE.container)}>
      <ListViewShell
        itemCount={items.length}
        loading={loading}
        emptyMessage="No labour items found"
      >
        <LedgerHeader
          columns={ITEMS_COLUMNS}
          collapse={ITEMS_COLLAPSE}
          titleLabel="Name"
          showValues={false}
          showActions
          hideBelow={ITEMS_COLLAPSE.at}
        />
        {items.map(item => (
          <LabourItemListItem
            key={item.id}
            item={item}
            columns={ITEMS_COLUMNS}
            collapse={ITEMS_COLLAPSE}
            onItemClick={onItemClick}
            disabled={disabled}
          />
        ))}
      </ListViewShell>
    </div>
  );
};
